export const camposFormulario = (tipoLogro = []) => {
    return {
        title: "Usuario",
        campos: [
            {
                name: "nombre",
                label: "Nombre del Logro",
                type: "text"
            },
            {
                name: "descripcion",
                label: "Descripción Logro",
                type: "text",
            },
            {
                name: "dificultad",
                label: "Dificultad Logro",
                type: "number"
            },
            {
                name: "tilo_id",
                label: "Tipo de Logro",
                type: "select",
                opciones: tipoLogro
            },
        ]
    }
}

export const columns = () => {

    return [
        {
            title: "Nombre",
            dataIndex: "nombre",
            width: "20%",
        },
        {
            title: "Descripcion",
            dataIndex: "descripcion",
            width: "40%",
        },
        {
            title: "Dificultad",
            dataIndex: "dificultad",
            width: "20%",
        },
        {
            title: "Tipo Logro",
            dataIndex: "tipoLogro",
            width: "20%",
        },
    ];
}
export const camposFormularioCrear = (logros = [], idUsuario = null) => {
    return {
        title: "Agregar logro al usuario",
        campos: [
            {
                name: "usua_id",
                label: "ID del usuario",
                type: "number",
                rules: [
                    {
                        required: true,
                        message: "Campo requerido",
                    }
                ],
                defaultValue: idUsuario,
                disabled: true,
            },
            {
                name: "logros",
                label: "Logro",
                type: "multiple",
                rules: [
                    {
                        required: true,
                        message: "Campo requerido",
                    }
                ],
                opciones: logros
            }
        ],
    }
}
